import type React from 'react';
import type { CSSProperties } from 'react';

import clsx from 'clsx';

import type { Partner } from '../model/domain/Partner';

import AppConfig from './../AppConfig';

export interface PartnerLogoProps {
  partner: Partner;
  style?: CSSProperties;
}

const PartnerLogo: React.FC<PartnerLogoProps> = ({ partner, style }) => {
  const isPartnerLinkValid = partner.url?.startsWith('http');

  return (
    <div className={clsx(style)}>
      {isPartnerLinkValid ? (
        <a href={partner.url} tabIndex={-1} target="_blank">
          <img
            alt="Logo of the partner"
            className="max-h-9 max-w-[200px] pr-[54px] object-contain"
            src={`${AppConfig.apiUrl}/files/${partner.logoId}`}
          />
        </a>
      ) : (
        <img
          alt="Logo of the partner"
          className="max-h-9 max-w-[200px] pr-[54px] object-contain"
          src={`${AppConfig.apiUrl}/files/${partner.logoId}`}
        />
      )}
    </div>
  );
};

export default PartnerLogo;
